module.exports = __webpack_public_path__ + "static/media/trim-donut-t.988698ca.png";